import React from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Brand } from "@/components/Brand";
import { LogOut, Map, ShoppingBag } from "lucide-react";

export default function CandidateLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      <header className="sticky top-0 z-40 bg-white border-b border-slate-200">
        <div className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-between">
          <Brand size="md" />
          <div className="flex items-center gap-3">
            <div className="hidden sm:flex flex-col items-end">
              <span className="text-xs font-medium text-slate-900">
                {user?.name}
              </span>
              <span className="text-[10px] font-mono uppercase tracking-widest text-slate-500">
                Candidate
              </span>
            </div>
            <button
              onClick={async () => {
                await logout();
                nav("/login");
              }}
              data-testid="candidate-logout-btn"
              className="p-2 rounded-md hover:bg-slate-100"
              aria-label="Logout"
            >
              <LogOut size={16} />
            </button>
          </div>
        </div>
        <nav className="max-w-6xl mx-auto px-4 flex gap-1 border-t border-slate-100">
          <NavLink
            end
            to="/candidate"
            data-testid="candidate-nav-wards"
            className={({ isActive }) =>
              `flex items-center gap-1.5 text-sm py-3 px-3 border-b-2 ${isActive ? "border-blue-700 text-blue-700 font-medium" : "border-transparent text-slate-600 hover:text-slate-900"}`
            }
          >
            <Map size={14} /> Wards Marketplace
          </NavLink>
          <NavLink
            to="/candidate/purchases"
            data-testid="candidate-nav-purchases"
            className={({ isActive }) =>
              `flex items-center gap-1.5 text-sm py-3 px-3 border-b-2 ${isActive ? "border-blue-700 text-blue-700 font-medium" : "border-transparent text-slate-600 hover:text-slate-900"}`
            }
          >
            <ShoppingBag size={14} /> My Reports
          </NavLink>
        </nav>
      </header>
      <main className="flex-1 max-w-6xl mx-auto w-full px-4 py-6 md:py-10">
        <Outlet />
      </main>
    </div>
  );
}
